export const PANE_C2C_PATH = ['accounts', 'phoneExpanded'];
export const ACCOUNT_PANE_PATH = ['accounts', 'activeAccount'];
export const ADD_TO_FLOW_DIALOG_KEY_PATH = ['accounts', 'addToFlow'];
export const REMOVE_ALL_FLOWS_DIALOG_KEY_PATH = [
  'accounts',
  'removeFromAllFlows',
];
export const SELECTED_PEOPLE_PATH = ['people', 'selected'];
export const ACCOUNT_PREVIEW_FLOW = 'AccountPreviewAddToFlow';
